export default "__VITE_ASSET__V4tX9LP9__"